/*
 * Mobiles Seitenmenue: Unterebenen nachladen (Liquid-Life Performance)
 *
 * Die Seite liefert nur die Hauptebene des Seitenmenues aus (snippets/navigation-panel.liquid, ll_lazy_panels). Die
 * Unterebenen (ca. 500 Eintraege) holt dieses Script von der Adresse in data-ll-menu-lazy - dort rendert
 * sections/header.liquid mit der Vorlage index.ll-menu nur das komplette Seitenmenue.
 *
 * Wann geladen wird:
 * - Handy/Tablet (Hamburger sichtbar, < 1150px): im Hintergrund, sobald die Seite fertig geladen ist und der Browser
 *   Luft hat. Bis jemand das Menue oeffnet, ist es in aller Regel schon da.
 * - Sobald jemand den Hamburger beruehrt/fokussiert, sofort.
 * - Desktop (>= 1150px): nie - dort gibt es das Seitenmenue nicht.
 * Tippt jemand eine Kategorie an, bevor die Unterebenen da sind, wird der Klick kurz angehalten und danach ausgefuehrt.
 * Schlaegt das Laden fehl, fuehrt der Klick direkt zur Kategorie-Seite (data-ll-href) - das Menue bleibt bedienbar.
 */
const wrapper = document.querySelector("#header-sidebar-menu [data-ll-menu-lazy]");

if (wrapper) {
  const drawer = wrapper.closest("navigation-drawer");
  let loading = null;

  const load = () => {
    loading ??= fetch(wrapper.dataset.llMenuLazy)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Menue nicht geladen (${response.status})`);
        }
        return response.text();
      })
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const panels = doc.querySelectorAll("#header-sidebar-menu .panel-list__wrapper > .panel:not(:first-child)");
        if (!panels.length) {
          throw new Error("Menue ohne Unterebenen");
        }
        wrapper.append(...Array.from(panels, (panel) => document.importNode(panel, true)));
        wrapper.removeAttribute("data-ll-menu-lazy");
      })
      .catch((error) => {
        loading = null; // naechster Versuch beim naechsten Anlass
        throw error;
      });
    return loading;
  };

  const loaded = () => !wrapper.hasAttribute("data-ll-menu-lazy");

  // Klick auf eine Kategorie, bevor die Unterebenen da sind: anhalten, laden, dann ausfuehren
  drawer.addEventListener(
    "click",
    (event) => {
      const button = event.target.closest("button[data-panel]");
      if (!button || loaded()) {
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      if (button.getAttribute("aria-busy") === "true") {
        return;
      }
      button.setAttribute("aria-busy", "true");
      load()
        .then(
          () => button.click(),
          () => {
            if (button.dataset.llHref) {
              window.location.href = button.dataset.llHref;
            }
          }
        )
        .finally(() => button.removeAttribute("aria-busy"));
    },
    true
  );

  // Hamburger beruehrt/fokussiert: sofort laden
  document.querySelectorAll('[aria-controls="header-sidebar-menu"]').forEach((opener) => {
    ["pointerdown", "focus", "mouseenter"].forEach((type) => {
      opener.addEventListener(type, () => load().catch(() => {}), { once: true, passive: true });
    });
  });

  // Handy/Tablet: im Hintergrund laden, wenn die Seite fertig ist
  const mobile = window.matchMedia("(max-width: 1149px)");
  const preload = () => {
    if (!mobile.matches || loaded()) {
      return;
    }
    const run = () => load().catch(() => {});
    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(run, { timeout: 3000 });
    } else {
      setTimeout(run, 1500);
    }
  };

  if (document.readyState === "complete") {
    preload();
  } else {
    window.addEventListener("load", preload, { once: true });
  }
  mobile.addEventListener("change", preload);
}
